<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ carrier.name }}
        </h1>
        <h1>
          {{ $tc('models.carrierSetting', 2) }}

          <!-- <v&#45;btn color="primary" v&#45;can:create="'CarrierSetting'" @click="goTo('newCarrierSetting', { carrierId: $route.params.carrierId })"> {{ $t('create') }} </v&#45;btn> -->

          <v-btn color="primary" outline @click="goTo('carriers')"> {{ $t('back') }} </v-btn>
          <v-btn color="primary" v-if="carrier.provider_code === 'Redpack' || carrier.provider_code === 'Estafeta' || carrier.provider_code === 'Carssa'" style="float: right;" @click="goTo('testConnections', {carrier_id: carrier.id})"> {{ $t('testConnections') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="items"
                      :loading="loading"
                      hide-actions
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <template>
              <td> {{ props.item.key }} </td>
              <td>
                <DiscoverData :value="props.item.value" :hidden="props.item.hidden" />
              </td>
              <td class="pa-0 pr-2 text-xs-right">

                <v-btn v-if="canEdit(props.item)" color="primary" flat icon @click="goTo('editCarrierSetting', props.item.id)">
                  <font-awesome-icon icon="edit"></font-awesome-icon>
                </v-btn>

              </td>
            </template>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Carrier from '@/client/carrier'
import CarrierSetting from '@/client/carrier-setting'
import DiscoverData from '../../components/shared/discover-data.vue'

export default {
  name: 'CarrierSettingsView',

  props: {},

  data () {
    return {
      headers: [
        { text: this.$t('attrs.key'), align: 'left', sortable: false, value: 'key' },
        { text: this.$t('attrs.value'), align: 'left', sortable: false, value: 'value' },
        { text: '', align: 'left', sortable: false, value: '' }
      ],
      items: [],
      loading: false,
      carrier: {},
      pagination: {
        rowsPerPage: 20,
        sortBy: 'created_at',
        descending: false
      }
    }
  },

  components: {
    DiscoverData
},

  computed: {
  },

  methods: {
    async fetch () {
      let obj = {}
      this.loading = true

      const { sortBy, descending } = this.pagination
      let order = ''
      if (sortBy) {
        order = `${sortBy} ${descending ? 'desc' : 'asc'}`
      }
      obj = {
        page: 1,
        per_page: 20,
        order,
        where: {
          carrier_id: this.carrier.id
        }
      }
      // this.items = await CarrierSetting.all(obj)
      let data = await CarrierSetting.all(obj)
      this.items = await CarrierSetting.HiddenData(data)
      this.loading = false
    },

    canEdit (item) {
      const isLimit = item.key == 'limit'
      const isDev = this.$auth.isDev()
      // const isAdmin = this.$auth.isAdmin()
      const isMainAdmin = this.$auth.isMainAdmin()

      if (isDev) { return true }
      if (isMainAdmin) { return true }
      if (isLimit) { return false }
      if (this.carrier.freeze_settings) { return false }

      return true
    },
  },

  watch: {
  },

  async mounted () {
    this.$auth.getCurrentUser()

    this.carrier = await Carrier.findOne(this.$route.params.carrierId)
    this.fetch()
  }
}
</script>
